import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { LetterTemplateType } from '../Enums/LetterTemplateType.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputWordDocumentTemplate<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: any;
  /** Alias: templateFilename */
  templateFilename?: any;
  /** Alias: body */
  body?: any;
  /** Alias: title */
  title?: any;
  /** Alias: serialLetter */
  serialLetter?: any;
  /** Alias: templateType */
  templateType?: LetterTemplateType;
  /** Alias: groupCode */
  groupCode?: any;
  /** Alias: folder */
  folder?: any;
  /** Alias: documentSubClass */
  documentSubClass?: any;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];
  /** Alias: settings */
  settings?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputWordDocumentTemplate> = {
  code: {
    alias: 'code',
  },
  templateFilename: {
    alias: 'templateFilename',
  },
  body: {
    alias: 'body',
  },
  title: {
    alias: 'title',
  },
  serialLetter: {
    alias: 'serialLetter',
  },
  templateType: {
    alias: 'templateType',
  },
  groupCode: {
    alias: 'groupCode',
  },
  folder: {
    alias: 'folder',
  },
  documentSubClass: {
    alias: 'documentSubClass',
  },
  customFields: {
    alias: 'customFields',
  },
  settings: {
    alias: 'settings',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputWordDocumentTemplateEntityDefinition: EntitiyDefinition<InputWordDocumentTemplate> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputWordDocumentTemplate',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
